// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#x-ConfigEditor-configBtn {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}\n", ""]);
// Exports
exports.locals = {
	"configBtn": "x-ConfigEditor-configBtn"
};
module.exports = exports;
